import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { ScrollView, ActivityIndicator, View } from 'react-native'

import Home from '../Home/Home'
import Search from '../Search'
import CountryRoaming from '../CountryRoaming'
import CountryDetails from '../CountryDetails'
import { ErrorScreen, VFScreen } from '@vfgroup-oneplatform/foundation/Components'

import RoamingContext from '../../Context'
import styles from './Roaming.Styles'
import axios from 'axios'



console.error = () => null

const Roaming = ({
  navigate,
  onClose,
  MSISDN,
  userType,
  getRoamingRecommendationOffer,
  getRoamingOfferBundles,
  getCountryFromCoordinates,
  theme,
  dataUrl
}) => {

  // Screen Enums
  const HOME = 'HOME'
  const SEARCHING = 'SEARCHING'
  const COUNTRY_ROAMING = 'COUNTRY_ROAMING'
  const COUNTRY_DETAILS = 'COUNTRY_DETAILS'

  const [screen, setScreen] = useState({ screen: HOME })
  const [selectedCountry, setSelectedCountry] = useState({})

  const [searchType, setSearchType] = useState('prepaid')

  const [loadingCountriesInfo, setLoadingCountriesInfo] = useState(false)
  const [countriesList, setCountriesList] = useState({})

  const contextValue = {
    roamingState: {
      onClose,
      screen,
      setScreen,
      selectedCountry,
      setSelectedCountry,
      countriesList,
      setCountriesList,
      navigate,
      searchType,
      setSearchType,
      MSISDN,
      userType,
      getRoamingRecommendationOffer,
      getRoamingOfferBundles,
      getCountryFromCoordinates,
      theme
    }
  }


  const getCountriesData = async () => {
    setLoadingCountriesInfo(true)

    try {
      const { data } = await axios.get(dataUrl)
      setCountriesList(data)
      setLoadingCountriesInfo(false)
    } catch (error) {
      setLoadingCountriesInfo(false)
    }

    // fetch(dataUrl)
    //   .then(response => response.json())
    //   .then(response => {
    //     setCountriesList(response)
    //     setLoadingCountriesInfo(false)
    //   })
    //   .catch(e => {
    //     
    //   })
  }



  useEffect(() => {
    getCountriesData()
  }, [])

  if (loadingCountriesInfo) {
    return <VFScreen title={'roaming_screen_title'} onClose={onClose}>
      <ActivityIndicator size={'large'} style={{ height: '100%', width: '100%', alignSelf: 'center' }} />
    </VFScreen>
  }

  if (!countriesList) {
    return <VFScreen title={'roaming_screen_title'} onClose={onClose}>
      <ErrorScreen onPress={getCountriesData} />
    </VFScreen>
  }

  if (!loadingCountriesInfo && countriesList) {
    return (
      <RoamingContext.Provider value={contextValue}>
        {screen.screen === HOME && (
          <Home />
        )}
        {screen.screen === SEARCHING && (
          <Search {...screen.props} />
        )}
        {screen.screen === COUNTRY_ROAMING && (
          <CountryRoaming />
        )}
        {screen.screen === COUNTRY_DETAILS && (
          <CountryDetails detailsProps={{ ...screen.props }} />
        )}

      </RoamingContext.Provider>
    )
  }

}

Roaming.defaultProps = {}

Roaming.propTypes = {
  navigate: PropTypes.func,
  onClose: PropTypes.func,
  MSISDN: PropTypes.string,
  userType: PropTypes.string,
  getRoamingRecommendationOffer: PropTypes.func,
  getRoamingOfferBundles: PropTypes.func,
  getCountryFromCoordinates: PropTypes.func,
  theme: PropTypes.object,
  dataUrl: PropTypes.string
}

export default Roaming
